// extracted by mini-css-extract-plugin
module.exports = {"uensList":"styles_uensList__wer56","uen":"styles_uen__13Up3"};